import { render, staticRenderFns } from "./MTipsFrame.vue?vue&type=template&id=cae3f34c&"
import script from "./MTipsFrame.vue?vue&type=script&lang=ts&"
export * from "./MTipsFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports